import React from 'react';
import './App.css';
import MainApp from './components/mainApp';
function App() {
  return (
    <MainApp/>
  );
}

export default App;
